import { Button } from '@genie-fintech/ui/components'
import { container, subContainer } from './styles.css'
import { flexRow } from '$styles/common.css'
import Link from '$router/Link'
import { ROUTE_NAMES } from '$router/config'

const NotFound = () => {
  return (
    <article className={container}>
      <article className={subContainer}>
        <article
          className={flexRow}
          style={{ gap: 8, justifyContent: 'center' }}
        >
          <span>404</span>
          <span>|</span>
          <span>Page Not Found</span>
        </article>
        <Link to={ROUTE_NAMES.INDEX} options={{ replace: true }}>
          <Button>Go to Home</Button>
        </Link>
      </article>
    </article>
  )
}

export default NotFound
